import { Component, OnInit, ViewChild, AfterViewInit, Output, EventEmitter, ElementRef, ViewEncapsulation } from '@angular/core';
import { MarketStatisticsModel } from './MarketStatistics.model';
import { ButtonComponent } from '../../../button/button.component';
import { FormComponent } from '../../../form/form.component';
import { ServiceStock } from '../../../service-stock.service';
import { HttpResponse } from '@angular/common/http';
import { ExchangeComponent } from '../../../gotx/components/Exchange/Exchange.component';
import { ProductComponent } from '../../../gotx/components/Product/Product.component';
import { GotxGridSimpleComponent } from '../../../gotx/components/gotx-grid-simple/gotx-grid-simple.component';
import { jqxScrollViewComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxscrollview';

const customCss: string = '';

@Component({
  selector: 'app-MarketStatistics',
  templateUrl: './MarketStatistics.component.html',
  encapsulation: ViewEncapsulation.None,
  styles: [`
    .jqx-scrollview-page-dark, .jqx-scrollview-page-light { overflow: auto; }
    `]
})
//
export class MarketStatisticsComponent extends FormComponent implements OnInit, AfterViewInit {
  @ViewChild('FieldId_1', { static: false }) FieldId_1: ElementRef;
  @ViewChild('cstmExchange', { static: false }) cstmExchange: ExchangeComponent;
  @ViewChild('cstmProduct', { static: false }) cstmProduct: ProductComponent;
  @ViewChild('btnSubmit', { static: false }) btnSubmit: ButtonComponent;
  @ViewChild('grpAdvance', { static: false }) grpAdvance: ElementRef;
  @ViewChild('loserGrid', { static: false }) loserGrid: GotxGridSimpleComponent;
  @ViewChild('gainerGrid', { static: false }) gainerGrid: GotxGridSimpleComponent;
  @ViewChild('grpActive', { static: false }) grpActive: ElementRef;
  @ViewChild('ValueGrid', { static: false }) ValueGrid: GotxGridSimpleComponent;
  @ViewChild('volumeGrid', { static: false }) volumeGrid: GotxGridSimpleComponent;
  @ViewChild('grpMovement', { static: false }) grpMovement: ElementRef;
  @ViewChild('tradeGrid', { static: false }) tradeGrid: GotxGridSimpleComponent;
  @ViewChild('mktStatsGrid', { static: false }) mktStatsGrid: GotxGridSimpleComponent;
  @ViewChild('btnAdvance', { static: false }) btnAdvance: ButtonComponent;
  @ViewChild('btnActive', { static: false }) btnActive: ButtonComponent;
  @ViewChild('btnMovement', { static: false }) btnMovement: ButtonComponent;
  @ViewChild('myScrollView', { static: false }) myScrollView: jqxScrollViewComponent;

  @Output() selectedRow = new EventEmitter<String>();

  skeletonContentLoaded = false;
  displayAdvance: boolean = false;
  displayActive: boolean = false;
  displayMovement: boolean = false;

  loserColumn: any;
  loserDataSource: any;
  gainerColumn: any;
  gainerDataSource: any;
  valueColumn: any;
  valueDataSource: any;
  volumeColumn: any;
  volumeDataSource: any;
  tradeColumn: any;
  tradeDataSource: any;
  mktStatsColumn: any;
  mktStatsDataSource: any;

  async revalidate(): Promise<number> {
    var totalErrors = 0;
    super.beforeRevalidate();
    await Promise.all([
      this.cstmExchange.revalidate(),
      this.cstmProduct.revalidate(),
    ]).then((errorCounts) => {
      errorCounts.forEach((errorCount) => {
        totalErrors += errorCount;
      });
    });
    this.errors = totalErrors;
    super.afterRevalidate();
    return totalErrors;
  }
  constructor(services: ServiceStock) {
    super(services);
    this.value = new MarketStatisticsModel();
    this.componentCode = 'MarketStatistics';
  }
  setReadOnly(readOnly) {
    super.setBasicFieldsReadOnly(readOnly);
    this.cstmExchange.setReadOnly(readOnly);
    this.cstmProduct.setReadOnly(readOnly);
  }
  async onFormLoad() {
    this.setInputs(this.services.dataStore.getData(this.services.routing.currModal));
    this.cstmExchange.cmbExchange.setFocus(true);
    this.setDependencies();
    this.cstmProduct.setProductDropDown();
  }
  setInputs(param: any) {
    let params = this.services.http.mapToJson(param);
    if (params['mode']) {
      this.mode = params['mode'];
    }
  }
  async submitForm(path, apiCode, serviceCode) {
    this.submitData['formName'] = 'MarketStatistics';
    await super.submit(path, apiCode, serviceCode);
  }
  getFieldInfo() {
    this.amountComponent.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    this.comboFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    // this.fileUploadFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    this.additionalInfo['cstmExchange_desc'] = this.cstmExchange.getFieldInfo();
    this.additionalInfo['cstmProduct_desc'] = this.cstmProduct.getFieldInfo();
    return this.additionalInfo;
  }
  getFieldValue() {
    this.value.cstmExchange = this.cstmExchange.getFieldValue();
    this.value.cstmProduct = this.cstmProduct.getFieldValue();
    return this.value;
  }
  setValue(inputValue, inputDesc = undefined) {
    this.setBasicFieldsValue(inputValue, inputDesc);
    this.cstmExchange.setValue(inputValue['cstmExchange'], inputDesc['cstmExchange_desc']);
    this.cstmProduct.setValue(inputValue['cstmProduct'], inputDesc['cstmProduct_desc']);
    this.value = new MarketStatisticsModel();
    this.value.setValue(inputValue);
    this.setDependencies();
    this.passNewValue(this.value);
  }
  ngOnInit() {
    if (this.formCode == undefined) { this.formCode = 'MarketStatistics'; }
    if (this.formOnLoadError) { return; }
    setTimeout(() => {
      this.skeletonContentLoaded = true;
    }, 1000);
    var styleElement = document.createElement('style');
    styleElement.type = 'text/css';
    styleElement.innerHTML = customCss;
    styleElement.id = 'MarketStatistics_customCss';
    document.getElementsByTagName('head')[0].appendChild(styleElement);
    this.displayActive = false;
    this.displayAdvance = true;
    this.displayMovement = false;
  }
  getMarketStatistics(optionSelected: string) {
    if (optionSelected == "displayAdvance") {
      this.displayActive = false;
      this.displayAdvance = true;
      this.displayMovement = false;
      this.myScrollView.currentPage(0);
    }

    else if (optionSelected == "displayActive") {
      this.displayActive = true;
      this.displayAdvance = false;
      this.displayMovement = false;
      this.myScrollView.currentPage(1);
    }
    else {
      this.displayActive = false;
      this.displayAdvance = false;
      this.displayMovement = true;
      this.myScrollView.currentPage(2);
    }
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    var styleElement = document.getElementById('MarketStatistics_customCss');
    styleElement.parentNode.removeChild(styleElement);
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.subsBFldsValueUpdates();
      this.value.cstmExchange = this.cstmExchange.getFieldValue();
      this.cstmExchange.valueChangeUpdates().subscribe((value) => { this.value.cstmExchange = value; });
      this.value.cstmProduct = this.cstmProduct.getFieldValue();
      this.cstmProduct.valueChangeUpdates().subscribe((value) => { this.value.cstmProduct = value; });
      this.onFormLoad();
      this.checkForHTabOverFlow();
      this.creatGridColumn();
      this.myScrollView.showButtons(false);
      this.myScrollView.theme(this.services.theme.themeName);
      this.btnSubmit_click();
    });
  }
  clearError() {
    super.clearBasicFieldsError();
    super.clearHTabErrors();
    super.clearVTabErrors();
    this.cstmExchange.clearError();
    this.cstmProduct.clearError();
    this.errors = 0;
    this.errorMessage = [];
  }
  onReset() {
    super.resetBasicFields();
    this.cstmExchange.onReset();
    this.cstmProduct.onReset();
    this.clearHTabErrors();
    this.clearVTabErrors();
    this.errors = 0;
    this.errorMessage = [];
    this.additionalInfo = undefined;
    this.dependencyMap.clear();
    this.value = new MarketStatisticsModel();
    this.passNewValue(this.value);
    this.setReadOnly(false);
    this.onFormLoad();
  }
  async btnSubmit_click() {

    let inputMap = new Map();
    var errorCount: number = await this.revalidate();
    document.getElementById('errMsgDiv').innerHTML = "";

    if (errorCount == 0) {
      this.myScrollView.currentPage(0);
      inputMap.clear();
      inputMap.set('Body.exchangeID', this.cstmExchange.cmbExchange.getFieldValue());
      inputMap.set('Body.productID', this.cstmProduct.cmbProduct.getFieldValue());
      this.services.http.fetchApi('/market/gainersloosers', 'POST', inputMap).subscribe(
        async (httpResponse: HttpResponse<any>) => {
          var res = httpResponse.body;
          var respCode: any = res['respCode'];
          if (respCode != null && respCode == 0) {

            this.gainerDataSource = res['response'][0]; // Order inter changed by Mirsha, 27.Oct.2022
            this.loserDataSource = res['response'][1];  // Order inter changed by Mirsha, 27.Oct.2022
            this.volumeDataSource = res['response'][2]; // Order Switched, Uat #bug, 08.Dec.2022
            this.valueDataSource = res['response'][3];  // Order Switched, Uat #bug, 08.Dec.2022
            this.tradeDataSource = res['response'][4];
            this.featchMoversData();
          }
          else {
            //document.getElementById('errMsgDiv').innerHTML = res['errMsg'];
	    //commented by Shanmuga Priya - VAPT
            const rawMsg = res['errMsg'];
            const plainMsg = rawMsg.replace(/<[^>]*>/g, ""); // remove HTML tags
            (document.getElementById('errMsgDiv') as HTMLElement).textContent = plainMsg;

          }
        },
        async (httpError) => {
          var err = httpError['error']
          if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
            if (err['ErrorElementPath'] == 'selectProduct') {
              this.cstmProduct.cmbProduct.setError(err['ErrorDescription']);
            }
            else if (err['ErrorElementPath'] == 'exchange') {
              this.cstmExchange.cmbExchange.setError(err['ErrorDescription']);
            }
          }
          document.getElementById('errMsgDiv').innerHTML = this.transalte('ErrorCodes.SystemDown');

        }
      );
    }
  }
  fieldDependencies = {
  }
  transalte(text) {
    return this.services.translate.instant(text);
  }

  creatGridColumn(): void {
    this.loserColumn = [
      { text: this.transalte('MarketStatisticsLosser.Stock'), datafield: 'symbol', width: "30%", cellsalign: 'left',height:"80%" },
      { text: this.transalte('MarketStatisticsLosser.PrevClose'), datafield: 'prevClosePrice', cellsalign: 'right', width: "25%", cellsformat: 'd', format: '1.2-2' },
      { text: this.transalte('MarketStatisticsLosser.LastPrice'), datafield: 'lastTradePrice', cellsalign: 'right', width: "25%", cellsformat: 'd', format: '1.2-2' },
      { text: this.transalte('MarketStatisticsLosser.Change'), datafield: 'changePct', cellsalign: 'right', width: "25%", cellsformat: 'd', format: '1.2-2' },
    ];
    this.gainerColumn = this.loserColumn;

    this.valueColumn = [
      { text: this.transalte('MarketStatisticsValue.Stock'), datafield: 'symbol', width: "22%", cellsalign: 'left' },
      { text: this.transalte('MarketStatisticsValue.Volume'), datafield: 'totalTradeQuantity', cellsalign: 'right', width: "10%", cellsformat: 'n' },
      { text: this.transalte('MarketStatisticsValue.Turnover'), datafield: 'totalTradeValue', cellsalign: 'right', width: "15%", cellsformat: 'd', format: '1.2-2' },
      { text: this.transalte('MarketStatisticsValue.NoofTrades'), datafield: 'totalNoOfTrade', cellsalign: 'right', width: "30%", cellsformat: 'n' },
      { text: this.transalte('MarketStatisticsValue.LastPrice'), datafield: 'lastTradePrice', cellsalign: 'right', width: "20%", cellsformat: 'd', format: '1.2-2' }

    ];
    this.volumeColumn = this.valueColumn;
    this.tradeColumn = this.valueColumn;

    this.mktStatsColumn = [
      { text: this.transalte('MarketmktStats.Exchange'), datafield: 'exchangeID', width: "15%", cellsalign: 'left' },
      { text: this.transalte('MarketmktStats.Product'), datafield: 'productID', cellsalign: 'left', width: "15%" },
      { text: this.transalte('MarketmktStats.NoofTrades'), datafield: 'totalTrades', cellsalign: 'right', width: "40%", cellsformat: 'n' },
      { text: this.transalte('MarketmktStats.Volume'), datafield: 'totalVolume', cellsalign: 'right', width: "20%", cellsformat: 'n' },
      { text: this.transalte('MarketmktStats.Turnover'), datafield: 'totalTurnOver', cellsalign: 'right', width: "20%", cellsformat: 'd', format: '1.2-2' }
    ];
  }
  async btnMovement_click() {
    this.myScrollView.currentPage(2);
  }

  async btnChangeView(page: number) {
    this.myScrollView.currentPage(page);
  }

  async featchMoversData() {
    var errorCount: number = await this.revalidate();
    let inputMap = new Map();
    if (errorCount == 0) {
      inputMap.clear();
      inputMap.set('Body.exchangeID', this.cstmExchange.cmbExchange.getFieldValue());
      inputMap.set('Body.productID', this.cstmProduct.cmbProduct.getFieldValue());
      this.services.http.fetchApi('/market/statistics', 'POST', inputMap).subscribe(
        async (httpResponse: HttpResponse<any>) => {
          var res = httpResponse.body;
          var respCode: any = res['respCode'];
          if (respCode != null && respCode == 0) {
            if (res['response'] && res['response'].length > 0) {
              res['response'][0].exchangeID = this.services.dataStore.getDispExch(res['response'][0].exchangeID);
            }
            this.mktStatsDataSource = res['response'];
          }
          else {
            //document.getElementById('errMsgDiv').innerHTML = res['errMsg'];
	    //commented by Shanmuga Priya - VAPT
            const rawMsg = res['errMsg'];
            const plainMsg = rawMsg.replace(/<[^>]*>/g, ""); // remove HTML tags
            (document.getElementById('errMsgDiv') as HTMLElement).textContent = plainMsg;

          }
        },
        async (httpError) => {
          var err = httpError['error']
          if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
            if (err['ErrorElementPath'] == 'productID') {
              this.cstmProduct.cmbProduct.setError(err['ErrorDescription']);
            }
            else if (err['ErrorElementPath'] == 'exchangeID') {
              this.cstmExchange.cmbExchange.setError(err['ErrorDescription']);
            }
          }
          document.getElementById('errMsgDiv').innerHTML = this.transalte('ErrorCodes.SystemDown');

        }
      );
    }
  }
} 